import { Button, IconButton } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";  // Importamos el ícono de WhatsApp

export const getHeaders = (handleCreatePDF) => [
  { field: "id", headerName: "Codigo", width: 80 },
  { field: "razon_social", headerName: "Razon Social", width: 150 },
  { field: "cli_name", headerName: "Nombre de Fantasia", width: 150 },
  {
    field: "createdAt",
    headerName: "Fecha",
    width: 130,
    valueGetter: (params) => {
      const date = new Date(params.row.createdAt);
      return date.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },

  { field: "sel_fullname", headerName: "Vendedor", width: 100 },
  { field: "totalpedidodesc", headerName: "Total", width: 100 },
  {
    field: "formapago",
    headerName: "Forma de Pago",
    width: 120,
    renderCell: (params) => {
      const fp = Number(params.row.formapago);

      // Tu texto actual
      let label = "";
      switch (fp) {
        case 0:
          label = "Pago en Local";
          break;
        case 1:
          label = "Transferencia";
          break;
        case 2:
          label = "Mercado Pago";
          break;
        default:
          label = "Sin definir";
      }

      // Obtenemos el estado del pedido desde row.oca_state
      const state = Number(params.row.oca_state);

      // Elegimos color
      const color =
        state === 0
          ? "green"
          : state === 1
            ? "red"
            : "gray";

      return (
        <span style={{ color, fontWeight: 600 }}>
          {label}
        </span>
      );
    },
  },
  {
    field: "whatsapp",
    headerName: "Contacto",
    width: 80,
    renderCell: (params) => {
      const tel = params.row.cli_tel;
      const fp = Number(params.row.formapago);
      const pedidoId = params.row.id;

      // Solo mostrar si tiene teléfono y es transferencia
      if (!tel || fp !== 1) return null;

      // Mensaje personalizado
      const mensaje = `Hola! Muchas gracias por su compra. Nos comunicamos por el pedido N° ${pedidoId}. Necesitamos terminar con el proceso de pago.`;

      // Codificar la URL
      const url = `https://wa.me/${tel}?text=${encodeURIComponent(mensaje)}`;

      return (
        <IconButton
          aria-label="contactar por whatsapp"
          color="success"
          onClick={() => window.open(url, "_blank")}
        >
          <WhatsAppIcon />
        </IconButton>
      );
    }
  },
  {
    field: "pdf",
    headerName: "PDF",
    width: 50,
    sortable: false,
    renderCell: (params) => {
      return (
        <IconButton
          aria-label="imprimir pdf"
          color="primary"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!params.row?.id) return;
            handleCreatePDF(params.row);
          }}
        >
          <PictureAsPdfIcon />
        </IconButton>
      );
    },
  },
];
